const HeaderTexts = {
	title: 'Configure Inputs',
};

export default HeaderTexts;
